import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("span", {
    class: ["device-slot-dot", [_ctx.slotDotClass, _ctx.slotIcon]]
  }, null, 2))
}